<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Truck"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedTrucks"
      :columns="columns"
      :total-rows="totalTrucks"
      :get-edit-url="getEditUrl"
    >
      <template #actions="{ row }">
        <q-td class="q-pa-none text-center">
          <q-btn
            size="sm"
            color="primary"
            label="Edit"
            @click="$router.push(getEditUrl(row))"
            class="q-mr-sm"
          />
          <q-btn
            size="sm"
            :color="row.is_active ? 'negative' : 'positive'"
            :label="row.is_active ? 'Deactivate' : 'Reactivate'"
            @click="toggleActive(row)"
          />
        </q-td>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'TruckTable',
  components: {
    BaseTable
  },
  data() {
    return {
      trucks: [],
      totalTrucks: 0,
      haulers: [], // For hauler dropdown
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'hauler_name', align: 'left', label: 'Hauler', field: 'hauler_name', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedTrucks() {
      return this.trucks.map(truck => ({
        ...truck,
        hauler_name: truck.hauler_id.name, // Assuming the API returns nested hauler object with `name`
        add_date: new Date(truck.add_date).toLocaleDateString(),
        edit_date: new Date(truck.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchTrucks();
    this.fetchHaulers();
  },
  methods: {
    fetchTrucks() {
      axios
        .get('/api/v1/truck/trucks/', { params: { show_inactive: true } })
        .then(response => {
          console.log(response.data);
          this.trucks = response.data;
          this.totalTrucks = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching trucks:', error);
        });
    },
    fetchHaulers() {
      axios
        .get('/api/v1/hauler/haulers/')
        .then(response => {
          this.haulers = response.data;
        })
        .catch(error => {
          console.error('Error fetching haulers:', error);
        });
    },
    onAdd() {
      this.$router.push('/truck/add');
    },
    getEditUrl(row) {
      return `/truck/edit/${row.id}`;
    },
    toggleActive(row) {
      axios
        .patch(`/api/v1/truck/trucks/${row.id}/`, { is_active: !row.is_active })
        .then(() => {
          this.$q.notify({
            color: 'green',
            message: `Truck ${row.is_active ? 'deactivated' : 'reactivated'}.`,
            icon: 'check'
          });
          this.fetchTrucks();
        })
        .catch(error => {
          console.error('Error updating truck active state:', error);
          this.$q.notify({
            color: 'red',
            message: 'Failed to update truck status.',
            icon: 'error'
          });
        });
    }
  },
  watch: {
    trucks() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the TruckTable here */
</style>
